import React, { useState, useEffect } from "react";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const GalleryImageForm = ({ onSuccess, initialData, onCancel }) => {
  const [caption, setCaption] = useState(initialData?.caption || "");
  const [image, setImage] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const formData = new FormData();
    formData.append("caption", caption);
    if (image) formData.append("image", image);
    try {
      let res;
      if (initialData && initialData.id) {
        res = await fetch(`${API_URL}/api/gallery/${initialData.id}/`, {
          method: "PATCH",
          headers: { Authorization: `Bearer ${localStorage.getItem("access_token") || ""}` },
          body: formData,
        });
      } else {
        res = await fetch(`${API_URL}/api/gallery/`, {
          method: "POST",
          headers: { Authorization: `Bearer ${localStorage.getItem("access_token") || ""}` },
          body: formData,
        });
      }
      if (!res.ok) throw new Error("Failed to save image");
      onSuccess && onSuccess();
    } catch (e) {
      setError(e.message || "Failed to save image");
    }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="vertical gap-10">
      <label>
        Caption
        <input
          className="input"
          type="text"
          value={caption}
          onChange={e => setCaption(e.target.value)}
          required
        />
      </label>
      <label>
        Image
        <input
          className="input"
          type="file"
          accept="image/*"
          onChange={e => setImage(e.target.files[0])}
          required={!initialData}
        />
      </label>
      {error && <div style={{ color: 'red' }}>{error}</div>}
      <div className="horizontal gap-10">
        <button className="btn-primary-primary" type="submit" disabled={loading}>{loading ? "Saving..." : "Save"}</button>
        {onCancel && <button className="btn-secondary" type="button" onClick={onCancel}>Cancel</button>}
      </div>
    </form>
  );
};

const GalleryImagesSection = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editImage, setEditImage] = useState(null);

  const fetchImages = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/api/gallery/`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("access_token") || ""}` },
      });
      if (!res.ok) throw new Error("Failed to fetch images");
      setImages(await res.json());
    } catch (e) {
      setError("Failed to load images");
    }
    setLoading(false);
  };

  useEffect(() => { fetchImages(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this image?")) return;
    try {
      const res = await fetch(`${API_URL}/api/gallery/${id}/`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${localStorage.getItem("access_token") || ""}` },
      });
      if (!res.ok) throw new Error();
      fetchImages();
    } catch {
      setError("Failed to delete image");
    }
  };

  return (
    <div>
      <div className="horizontal gap-10 align-center" style={{ marginBottom: 20 }}>
        <h1>Slider or Gallery Images</h1>
        <button className="btn-primary-primary" onClick={() => { setEditImage(null); setShowModal(true); }}>Add New Image</button>
      </div>
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" style={{ width: "60%" }} onClick={e => e.stopPropagation()}>
            <GalleryImageForm
              initialData={editImage}
              onSuccess={() => { setShowModal(false); setEditImage(null); fetchImages(); }}
              onCancel={() => { setShowModal(false); setEditImage(null); }}
            />
          </div>
        </div>
      )}
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {loading ? (
        <div>Loading images...</div>
      ) : (
        <div className="gallery-card-container" style={{ display: 'flex', flexWrap: 'wrap', gap: 20 }}>
          {images.length === 0 ? (
            <div>No images found.</div>
          ) : (
            images.map(img => (
              <div key={img.id} className="gallery-card" style={{ border: '1px solid #eee', borderRadius: 8, padding: 10, width: 220, background: '#fff', boxShadow: '0 2px 8px #0001' }}>
                <img src={img.image} alt={img.caption} style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 6 }} />
                <div style={{ margin: '10px 0', fontWeight: 500 }}>{img.caption}</div>
                <div className="horizontal gap-10">
                  <button className="btn-primary-primary" onClick={() => { setEditImage(img); setShowModal(true); }}>Edit</button>
                  <button className="btn-secondary" onClick={() => handleDelete(img.id)}>Delete</button>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default GalleryImagesSection;
